import { Box, Button, Divider, TextField, Typography } from '@mui/material'
import { ChangeEvent, FC, FormEvent, useState } from 'react'
import { CustomDatePicker } from '../../../../../../components/CustomDatePicker'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../../../../store'
import { MatchedPFActions, MatchedPFSelector } from '../../../../../../store/matchedPF'
import { SnackbarActions } from '../../../../../../store/snackbar'

interface PFGrantFormProps {
  title: string
  projectId: string
  matchedPFId: string
  onSuccess: () => void
}

export const PFGrantForm: FC<PFGrantFormProps> = ({ title, matchedPFId, projectId, onSuccess }) => {
  const dispatch = useDispatch<AppDispatch>()

  const [formData, setFormData] = useState({
    title: '',
    amount: '',
    dueDate: null,
  })

  const loading = useSelector(MatchedPFSelector.getLoading)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    if (name === 'grantAmount') {
      if (value === '' || /^\d*\.?\d*$/.test(value)) {
        const decimalCount = (value.match(/\./g) || []).length

        decimalCount <= 1 && setFormData((prev) => ({ ...prev, [name]: value }))
      }

      return
    }

    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleDateChange = (date: any) => {
    setFormData((prev) => ({ ...prev, dueDate: date ? date.toISOString() : null }))
  }

  const handleAddGrant = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const result = await dispatch(MatchedPFActions.createMatchedPFGrantsAsync({
      technologyId: projectId,
      refId: matchedPFId,
      body: [{...formData, amount: parseInt(formData.amount)}],
    }))

    if (MatchedPFActions.createMatchedPFGrantsAsync.fulfilled.match(result)) {

      dispatch(SnackbarActions.showSnackbar({
        message: 'grant created successfully!!!',
        options: { variant: 'success' },
      }))

      onSuccess()
    }
  }

  return (
    <Box p={2}>
      <Typography fontSize="1.2rem" fontWeight={600} color="secondary">{title}</Typography>

      <Divider sx={{ my: 3 }} />

      <Typography mb={2.5} color="secondary" fontSize="1rem" fontWeight={600}>
        Add Grant
      </Typography>

      <form autoComplete="off" onSubmit={handleAddGrant}>
        <Box mb={2}>
          <Typography mb={1} color="secondary" fontSize="0.875rem" fontWeight={500}>
            Grant name
          </Typography>
          <TextField
            required
            fullWidth
            type="text"
            name="title"
            variant="outlined"
            onChange={handleChange}
            value={formData.title}
            placeholder="Enter grant name"

          />
        </Box>

        <Box mb={2}>
          <Typography mb={1} color="secondary" fontSize="0.875rem" fontWeight={500}>
            Amount
          </Typography>
          <TextField
            required
            fullWidth
            type="text"
            name="amount"
            variant="outlined"
            onChange={handleChange}
            value={formData.amount}
            placeholder="Enter grant amount"
          />
        </Box>

        <Box mb={2}>
          <Typography mb={1} color="secondary" fontSize="0.875rem" fontWeight={500}>
            Due date
          </Typography>

          <CustomDatePicker
            slotProps={{}}
            sx={{ width: '100%' }}
            onSelect={handleDateChange}
            value={formData.dueDate ? moment(formData.dueDate) : null}
          />
        </Box>

        <Button
          fullWidth
          type="submit"
          disableElevation
          variant="contained"
          disabled={loading}
          sx={{
            mt: 2.5,
            height: '52px',
            fontSize: '14px',
            borderRadius: '6px',
            textTransform: 'none',
          }}
        >
          Add Grant
        </Button>
      </form>
    </Box>
  )
}